function isRequired(label: string): string {
  return `* ${label}`;
}

function fieldLabel(label: string, required = false): string {
  return required ? isRequired(label) : label;
}

export { fieldLabel, isRequired };
